import {
    APP_LOAD,
    LOGIN,
    REGISTER,
    REDIRECT,
    LOGOUT,
    REQUIRE_AUTH,
    NEW_CLIENT_SUBMITED,
    UPLOAD_PROGRESS,
    USER_UPDATE,
    MESSAGE_SENDED,
    MESSAGE_CLOSED,
    DUPLICATE_CLIENT
} from "../constants/actionTypes";

const defaultState = {
    token: null,
    upload: {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
    case APP_LOAD:
        return {
            ...state,
            token: action.token || null,
            appLoaded: true,
            user: action.payload ? action.payload.user : null,
        };
    case REDIRECT:
        return {...state, redirectTo: null};
    case LOGOUT:
        return {...state, redirectTo: "/welcome", token: null, user: null};
    case REQUIRE_AUTH:
        return {...state, redirectTo: "/welcome", history: action.prevPath};
    case USER_UPDATE:
        const { permissions, _id } = action.user;

        return {
            ...state,
            user: Object.assign(state.user, (state.user.id == _id ? { permissions } : {}))
        };
    case NEW_CLIENT_SUBMITED:
        const { id, clientId } = action.payload;
        return { ...state, redirectTo: state.user.permissions.includes("client") ? `/client/${clientId}/car/${id}` : "/loans" };
    case LOGIN:
    case REGISTER:
        const {user} = action.payload;
        return {
            ...state,
            redirectTo: state.history || "/",
            token: user.token,
            user: user
        };
    case DUPLICATE_CLIENT:
        return {
            ...state,
            redirectTo: "/loans",
        };
    case MESSAGE_SENDED:
        return {
            ...state,
            message: action.payload,
            showMessage: true,
        };
    case MESSAGE_CLOSED:
        return {
            ...state,
            message: null,
            showMessage: false,
        };
    case UPLOAD_PROGRESS:
        const {name, percent} = action.payload;
        return {
            ...state,
            upload: {
                ...state.upload,
                [name]: percent,
            },
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/common.js